module.exports = __webpack_public_path__ + "static/img/li3_1.fc97442d.png";